
//sort data that nested under names array
// export const sortDic = (data, names) => {
//   console.log('data', data);
//   console.log('names', names);

//   var final = [];
//   // console.log(data)

//   for (var key in data){
//     var d = data[key] ;
//     console.log(d)

//     // if (d !== {} && d.length){

//       var id = Object.keys(d);
//       console.log(id);

//       // if (d[id]){
//         d[id]['Name'] = names[id];

//         final.push(d)
//         // console.log('final',final)
//       // }

//     // }




//   }

//   // console.log(final)

//   data = sort('Name', final)
//   // console.log(data)

//   return {data: data}
// }

/**
 * Enriches nested row objects with display `Name` from `names`, collects them into an array, then sorts by `Name`.
 * Each outer `data` value must be an object whose first key is an employee/id key pointing to the row payload.
 * @param {Object.<string, Object>} data Map of outer keys to inner objects `{ [id]: rowPayload }`.
 * @param {Object.<string, string>} names Map of inner id key to display name assigned as `rowPayload.Name`.
 * @return {{ data: Array<Object> }} `{ data }` where `data` is the sorted array of inner wrapper objects (mutated in place).
 */
export const sortDic = (data, names) => {
  console.log('data', data);
  console.log('names', names);

  var final = [];

  for (var key in data){
    var d = data[key] ;
    console.log(d)

    // 1. Get the array of keys
    var id_keys = Object.keys(d);
    console.log(id_keys);
    
    // 2. CRITICAL FIX: Extract the actual key (the first element)
    // Check if the array is not empty before accessing the index
    if (id_keys.length > 0) {
        var id = id_keys[0]; 

        // 3. Now use the actual string ID to access the property
        if (d[id] && typeof d[id] === 'object') { // Inner payload should be an object
            d[id]['Name'] = names ? names[id] : undefined;

            // You are pushing the outer container 'd' which includes the ID key
            final.push(d);
        } else {
            console.warn(`Data structure error: d[${id}] is undefined for key ${key}`);
        }
    } else {
         console.warn(`Skipping key ${key}: Inner object is empty.`);
    }

  }

  data = sort('Name', final)

  return {data: data}
}

/**
 * Sorts an array of objects in place by comparing `Name` on each item's nested object (case-insensitive).
 * Each element is expected to look like `{ [someKey]: { Name: string, ... } }`.
 * @param {string} prop Sort key name (call sites use `'Name'`; comparators read `.Name` on nested values).
 * @param {Array<Object>} arr Array of wrapper objects to sort **mutated in place**.
 * @return {Array<Object>} The same array reference, ordered by nested `Name`.
 */
export const sort = function (prop, arr) {
    arr.sort(function (a, b) {
      var nameA = '';
      var nameB = '';

      // Comparator expects each wrapper object to hold a single inner payload,
      // but we handle missing/malformed payloads safely.
      for (var ka in a){
          if (a[ka] && a[ka].Name !== null && a[ka].Name !== undefined){
            nameA = String(a[ka].Name).toUpperCase();
            break;
          }
      }

      for (var kb in b){
          if (b[kb] && b[kb].Name !== null && b[kb].Name !== undefined){
            nameB = String(b[kb].Name).toUpperCase();
            break;
          }
      }

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    })

    return arr;

};
